var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"f824218e47b2e32220b04a89807c34ea044c4dbc"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["hoyer-xp@harlapp-gmbh"]={id:"f824218e47b2e32220b04a89807c34ea044c4dbc"};
      